import {createRouter, createWebHistory} from 'vue-router'
import {useConfigStore} from "../stores/config.ts";
import { routes, handleHotUpdate } from 'vue-router/auto-routes'

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes
})

router.beforeEach(() => {
        const config = useConfigStore();
        config.openMenu = false;
})

if (import.meta.hot) { 
  handleHotUpdate(router) 
} 

export default router